import React from 'react';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import {SelectRefType} from '@guestapp/old-ui-kit';
import {
  QueriedInfiniteScrollSelect,
  QueriedInfiniteScrollSelectProps,
} from './QueriedInfiniteScrollSelect';
import {MobileQueriedInfiniteScrollSelect} from './MobileQueriedInfiniteScrollSelect';

const AdaptiveQueriedInfiniteScrollSelectInternal = <T, V, L>(
  props: QueriedInfiniteScrollSelectProps<T, V, L>,
  ref: React.ForwardedRef<SelectRefType<T, V, L>>,
) => {
  const {isMatch: isMobileMode} = useScreenResize(DEVICE.laptop);

  if (isMobileMode) {
    return <MobileQueriedInfiniteScrollSelect ref={ref} {...props} />;
  }

  return <QueriedInfiniteScrollSelect ref={ref} {...props} />;
};

const AdaptiveQueriedInfiniteScrollSelect = React.forwardRef(
  AdaptiveQueriedInfiniteScrollSelectInternal,
) as <T, V, L>(
  props: QueriedInfiniteScrollSelectProps<T, V, L> & {
    ref?: React.ForwardedRef<SelectRefType<T, V, L>>;
  },
) => ReturnType<typeof AdaptiveQueriedInfiniteScrollSelectInternal>;

export {AdaptiveQueriedInfiniteScrollSelect};
